import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss']
})
export class FileListComponent implements OnInit {
  @Input() fileEl!: HTMLInputElement;
  @Input() files: FileListItem[] = [];
  @Input() removable: boolean = true;
  @Input() template!: TemplateRef<any>;

  @Output() onClick = new EventEmitter<any>();
  @Output() onRemoveAll = new EventEmitter<FileListItem>();
  @Output() onRemove = new EventEmitter<any>();
  loadImage: boolean = false;
  imageShow: any;


  attachmentArr: any = [];

  ngOnInit(): void {
    this._initFileEl();
  }

  // detachFile(arr: any) {
  //   console.log('test file1.1', arr)
  //   let arrImage: any[] = [];
  //   let arrAttachment: any[] = [];
  //   arr.forEach((element: any) => {
  //     if (this._fileIsImage(element)) {
  //       arrImage.push(element)
  //     } else {
  //       arrAttachment.push(element)
  //     }
  //   });
  //   console.log('test file1.2', arrImage)
  //   console.log('test file1.3', arrAttachment)
  //   console.log('file + image', {image: arrImage, attachment: arrAttachment})
  //   return {image: arrImage, attachment: arrAttachment};
  // }

  clickFile(file: FileListItem, event: any) {
    this.onClick.emit({file, event});
  }


  removeAllFile(file: any) {
    // const index = this.files.indexOf(file);
    // if (index > -1) {
    //     this.files.splice(index, 1);
    //     // this.convertGallery(this.detachFile(this.files));
    // }
    this.attachmentArr = [];
    this.files = [];
    this.onRemoveAll.emit(file);
  }

  removeFile(file: any) {
    this.attachmentArr.forEach((item: any) => {
      if (item === file) {
        this.attachmentArr.splice(this.attachmentArr.indexOf(item), 1);
      }
    })
    this.onRemove.emit(file)
  }

  addFiles(files: FileList | File[]) {
    // Read as base64 if image
    let file: any;
    for (let i = 0; i < files.length; i++) {
      file = files[i];
      if (this._fileIsImage(file)) {
        file['image'] = true;
        this._readImageBase64(file);
      }
      this.files.push(file);
    }
    setTimeout(() => {
      this.convertGallery(this.files);
    }, 200);
    console.log('files', this.files);
  }

  convertGallery(arr: any) {
    let arrImage: any[] = [];
    arr.forEach((ele: any) => {
      if (this._fileIsImage(ele)) {
        let item: any = {};
        item = ele || {};
        item['small'] = ele.url;
        item['medium'] = ele.url;
        item['big'] = ele.url;
        arrImage.push(item);
      } else {
        arrImage.push(ele);
      }
    });
    // console.log('result', arrImage)
    // arr.image.forEach((ele: any) => {
    //   let item: any = {};
    //   item = ele || {};
    //   item['small'] = ele.url;
    //   item['medium'] = ele.url;
    //   item['big'] = ele.url;
    //   arrImage.push(item)
    // });
    this.attachmentArr = arrImage;
  }


  private _initFileEl() {
    if (this.fileEl) {
      this.fileEl.addEventListener('change', (e: any) => {
        const files: any = this.fileEl.files;
        if (files && files.length > 0) {
          // Read as base64 if image
          this.addFiles(files);
          // Reset file
          this.fileEl.value = '';
        }
      });
    }
  }

  private _readImageBase64(file: any) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      file.url = reader.result;
    };
  }

  _fileIsImage(file: FileListItem) {
    return (file.type && file.type.indexOf('image') > -1) || file.image;
    // return file.image;
  }

  viewImage() {
    this.loadImage = !this.loadImage;
  }

  currentImage(image: any) {
    this.imageShow = image;
  }


  next(attachmentArr: any, image: any) {
    const index = attachmentArr.indexOf(image)
    if (index < attachmentArr.length - 1) {
      this.imageShow = attachmentArr[index + 1];
    } else if (index + 1 > attachmentArr.length - 1) {
      this.imageShow = attachmentArr[0];
    }
  }

  prev(attachmentArr: any, image: any) {
    const index = attachmentArr.indexOf(image)
    if (index === 0) {
      this.imageShow = attachmentArr[attachmentArr.length - 1];
    } else if (index > 0 && index <= attachmentArr.length - 1) {
      this.imageShow = attachmentArr[index - 1];
    }
  }
}

export interface FileListItem extends File {
  id?: string;
  url?: string;
  image?: boolean;
}
